// extracted by mini-css-extract-plugin
export default {"popupBackground":"CouponDetails_popupBackground__lbMxN","parentDiv":"CouponDetails_parentDiv__OoAvm","copy":"CouponDetails_copy__EelXv"};